export const priceToWithoutTax = (priceWithTax: number, taxRate = 0.1) => {
  return Math.round(priceWithTax / (1 + taxRate));
};

export const priceToWithTax = (priceWithoutTax: number, taxRate = 0.1) => {
  return Math.round(priceWithoutTax * (1 + taxRate));
};
